import React from 'react';
import { Modal } from 'antd';
import { noop } from 'lodash';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';

interface IProps {
  title: string;
  before: object | null;
  after: object | null;
  visible?: boolean;
  onCancel?: any;
}

const DiffViewer: React.FC<IProps> = ({
  title, before, after, visible = false, onCancel = noop,
}) => {
  const newYaml = after === null ? '' : JSON.stringify(after, null, 4);
  const oldYaml = before === null ? '' : JSON.stringify(before, null, 4);

  return (
    (<Modal
      title={title}
      open={visible}
      footer={null}
      onCancel={onCancel}
      width="80%"
    >
      <ReactDiffViewer
        oldValue={oldYaml}
        newValue={newYaml}
        hideLineNumbers
        compareMethod={DiffMethod.LINES}
      />
    </Modal>)
  );
};

export default DiffViewer;
